import {Box, Typography} from "@mui/material"
import React from "react"
import {SelectOneScreen} from "components/SelectOneScreen"
import {NAVY} from "theme"

// Answer values exported so the orchestrator can set the pathway flag:
//   Yes -> Pathway 1, No -> Pathway 2 (both continue to the eligibility overview).
export const PRACTITIONER_YES = "Yes"
export const PRACTITIONER_NO = "No"

const OPTIONS = [PRACTITIONER_YES, PRACTITIONER_NO]

interface EligibilityPractitionerProps {
  value: string
  onSelect: (answer: string) => void
  onContinue: () => void
  onBack: () => void
}

// Screen 4 (moved from the end of the assessment). The FamilyDoctor question is
// now a dedicated screen; the broken "Here's a list of who can certify..." text
// is removed. Selecting "No" shows an on-screen AbilityDocs reassurance.
export const EligibilityPractitioner: React.FC<EligibilityPractitionerProps> = (
  props: EligibilityPractitionerProps
) => {
  const {value, onSelect, onContinue, onBack} = props
  return (
    <SelectOneScreen
      heading="Do you have a family doctor or medical practitioner who is willing to review and sign your application?"
      options={OPTIONS}
      value={value}
      onSelect={onSelect}
      onContinue={onContinue}
      onBack={onBack}
    >
      {value === PRACTITIONER_NO && (
        <Box marginTop={3}>
          <Typography fontSize="18px" color={NAVY} lineHeight={1.6}>
            {
              "That's okay. If you don't have a medical practitioner, yours is not supportive of your application, or you simply don't feel comfortable asking them, we can connect you with one through our AbilityDocs network."
            }
          </Typography>
        </Box>
      )}
    </SelectOneScreen>
  )
}

export default EligibilityPractitioner
